import { BALANCE_VALUE, LAST_WIN_VALUE } from '../../stateManagment';
import { gameService } from '../apiServices/GameService';
import { errorHandler } from '../ErrorHandler';
import { delay } from 'bog-arcade-core-ui/helpers';

class UserService {
  constructor() {
    this.timer = null;
  }

  updateLastWin(amount) {
    delay(() => {
      LAST_WIN_VALUE.next(amount);
    },1000)
  }

  updateBalance(res, callback) {
    if (!gameService.isRealMode) {
      return callback();
    }
   this.balance = res
  }

   async holdUpdateBalance(timeOut = 4000) {
    this.timer = setTimeout(() => {
      gameService.getBalance().then((res) => {
        this.updateBalance(res)
      });
    }, timeOut);
  }

  minusBalance(num) {
    BALANCE_VALUE.next(+BALANCE_VALUE.getValue() - num);
  }

  plusBalance(win) {
    if(gameService.isRealMode){
      this.holdUpdateBalance()
    }else {
      delay(() => {
        BALANCE_VALUE.next(+BALANCE_VALUE.getValue() + win);
      },1000)
    }
    this.updateLastWin(win);
  }

  get balance() {
    return BALANCE_VALUE.getValue();
  }

  set balance(value) {
    BALANCE_VALUE.next(value);
  }

  updateBalanceBuyBonusData(data) {
    if (data && data.hasOwnProperty('balance')) {
      this.updateBalance(data.balance);
    }
  }

  checkBalance(amount) {
    if (this.balance - amount >= 0) {
      return true;
    } else {
      errorHandler.notEnoughMoney();
      return false;
    }
  }
}

export const userService = new UserService();
